let LinearGradientPackage;
try {
  LinearGradientPackage = require('react-native-linear-gradient');
} catch (error) {}
export default LinearGradientPackage;